"use client";
//#region packages/@mantine/core/src/core/utils/create-event-handler/create-event-handler.ts
function createEventHandler(parentEventHandler, eventHandler) {
	return (event) => {
		parentEventHandler?.(event);
		eventHandler?.(event);
	};
}
//#endregion
export { createEventHandler };

//# sourceMappingURL=create-event-handler.mjs.map